module.exports = __webpack_public_path__ + "media/images/emoticons/yen-19a31f5f1b9518db193b61a5e1712577.gif";